import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-upload-form',
    template: `
    <p>
      upload-form works!
    </p>
  `,
    styles: []
})
export class UploadFormComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/theme/pages/default/upload-form/upload-form.component.ts